import React from 'react';
import { Box, Modal, Grid, Zoom, } from '@mui/material';
import {
    AddButton, CancelButton, DataInputForm, InputBox, ModalLabel,
    modalStyle, TextFieldBox, TextFieldForm, TextFieldLabel
} from './addAccount.styles';
import SwalUtil from "../../shared/util/sweetalert/sweetalertUtil";
import accountChangeApi from '../../shared/api/accountChange';
import { AccountLimit, SystemErrorMsg, SystemErrorTitle, SystemError, AccountDuplication, DuplicationMsg } from '../../constants';
import { useNavigate } from "react-router-dom";
import { BackdropLoading } from '../../shared/spinner/backdropLoading';
import { sessionDisconnectedCheck } from '../../shared/api/sessionDisconnectedCheck';
import { fetchAuthSession } from 'aws-amplify/auth';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void,
    onAction: () => void
}

const screenId = "U031"

const AddAccountModal = (props: OwnProps) => {
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [mailAddress, setMailAddress] = React.useState("");
    const [loading, setLoading] = React.useState<boolean>(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        (async () => {
            setOpen(isOpen);
            if (isOpen) {
                setOpen(false);
                setLoading(true);
                // アカウント情報変更API 操作フラグ = 1: 追加
                const response = await accountChangeApi("", "", "1")
                setLoading(false);
                if (response === SystemError) {
                    navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
                } else if (response === AccountLimit) {
                    // クライアント数上限エラー
                    setOpen(false)
                    SwalUtil.labelInfo({
                        title: "クライアント数上限",
                        message: "クライアント数が上限に達しているため、<br/>新規アカウントの追加ができません",
                        icon: "error",
                        confirmButtonText: "OK",
                        buttonAlign: "right",
                    }).then(async () => {
                        handleClose(false);
                    });
                } else {
                    setOpen(true);
                }
            }
        })()
    }, [isOpen])

    const handleAdd = async () => {
        // ログインユーザ取得
        const session = await fetchAuthSession();
        let login = session?.tokens?.idToken?.payload.email;
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "handleAdd", navigate)) {
            return
        }
        // 入力チェック
        if (!mailAddress) {
            SwalUtil.labelInfo({
                title: "入力エラー",
                message: "メールアドレスが未入力です。",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else if (!mailAddress.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) {
            SwalUtil.labelInfo({
                title: "入力エラー",
                message: "メールアドレスの形式が不正です。",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else {
            setLoading(true);
            // アカウント情報変更API 操作フラグ = 1: 追加
            const response = await accountChangeApi("", mailAddress, "1")
            if (response === SystemError) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            } else if (response === AccountDuplication) {
                SwalUtil.labelInfo({
                    title: "重複エラー",
                    message: DuplicationMsg,
                    icon: "error",
                    confirmButtonText: "OK",
                    buttonAlign: "right",
                });
                 setLoading(false);
            } else {
                if (login === mailAddress) {
                    // 管理者兼利用者に変更された場合は、セッションリフレッシュ
                    await fetchAuthSession({ forceRefresh: true });
                }
                props.onAction();
                setLoading(false);
                handleClose(false);
                navigate("/account", {});
            }
        }
    }

    const handleChange = (v: string) => {
        setMailAddress(v)
    }

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            アカウント追加
                        </ModalLabel>
                        <Box p={1} sx={{ marginTop: '2rem', marginLeft: '4rem', fontSize: '1.3rem', fontWeight: 320, textAlign: 'left' }}>
                            以下のメールアドレスにアカウント初期登録用メールを<br />送信します
                        </Box>
                        <InputBox>
                            <TextFieldBox border={1}>
                                <Grid container>
                                    <TextFieldLabel size={3}>メールアドレス</TextFieldLabel>
                                    <TextFieldForm size={9}>
                                        <DataInputForm placeholder="メールアドレスを入力" fullWidth variant='outlined' size='small' onChange={(e) => handleChange(e.target.value)} />
                                    </TextFieldForm>
                                </Grid>
                            </TextFieldBox>
                        </InputBox>
                        <Box>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={6} />
                                <Grid size={3}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                </Grid>
                                <Grid size={3}>
                                    <AddButton variant="contained" onClick={() => handleAdd()}>OK</AddButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default AddAccountModal;
